import { Box, BoxProps } from "@mantine/core"
import { useBreakpoints } from "../../../utils/use-breakpoints"

interface Props extends BoxProps, React.PropsWithChildren {}

export function ColumnLayout({ children, ...props }: Props) {
  const breakpoints = useBreakpoints()

  let columnCount = 1

  if (breakpoints.md || breakpoints.lg) {
    columnCount = 2
  } else if (breakpoints.xl || breakpoints.xxl) {
    columnCount = 3
  } else if (breakpoints.xxxl) {
    columnCount = 4
  }

  return (
    <Box
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
        gridAutoRows: "minmax(auto, 80%)",
      }}
      {...props}
    >
      {children}
    </Box>
  )
}
